import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { etiquetaCorte, etiquetaCortes } from 'src/app/utils/liquidacion-cortes';
import { guardarArchivo } from 'src/app/utils/descargar';

/**
 * LIQUIDACIÓN · LOTES DE PAGO (5.5; maqueta aprobada, vistas 6 y 7).
 *
 *   Lista   tandas aprobadas sin lote (el tesorero elige la cuenta origen y lo arma), procesos abiertos con su
 *           paso, e histórico con filtros.
 *   Ficha   cabecera (monto, tasa, pagos, de dónde sale), los 5 pasos con quién y cuándo, la acción del paso
 *           actual, los pagos y su resultado. La respuesta es el mismo Excel del lote: se sube, se ve la vista
 *           previa y recién entonces se aplica (Mario, 08-oct). Una fila mala rechaza todo y se listan.
 * Las reglas viven en el núcleo; aquí se muestra lo que el núcleo resolvió. Sin diálogos.
 */
@Component({
  selector: 'app-liquidacion-lotes',
  templateUrl: './liquidacion-lotes.component.html',
  styleUrls: ['./liquidacion-lotes.component.css']
})
export class LiquidacionLotesComponent implements OnInit, OnChanges {
  /** 13.4: el corte de cada tanda, liquidación o pago, tal como lo manda el núcleo. */
  readonly etiquetaCorte = etiquetaCorte;
  readonly etiquetaCortes = etiquetaCortes;
  @Input() dia = '';

  // Cada paso con su ícono y lo que pasa en él (supermódulo de pago, Mario 12-oct).
  readonly PASOS = [
    { k: 'generated', t: 'Generar archivo', i: 'fa-file-signature', d: 'Fija la tasa BCV del día, toma la foto de cada cuenta destino y la suma de control.' },
    { k: 'downloaded', t: 'Descargar', i: 'fa-download', d: 'Baja el archivo o el Excel del lote para llevarlo a la banca.' },
    { k: 'sent', t: 'Pagado en la banca', i: 'fa-university', d: 'Haz las transferencias desde la cuenta origen y márcalo aquí cuando termines.' },
    { k: 'response', t: 'Cargar respuesta', i: 'fa-file-import', d: 'Carga lo que respondió el banco: cada pago con su referencia, o su motivo si no se procesó.' },
    { k: 'closed', t: 'Finalizado', i: 'fa-flag-checkered', d: 'El lote se cierra y cada comercio pagado recibe su aviso.' },
  ];
  readonly ESTADOS = ['BORRADOR', 'GENERADO', 'DESCARGADO', 'ENVIADO', 'RESPUESTA_PARCIAL', 'CERRADO', 'ANULADO'];

  cargando = false;
  error = '';
  detalle: string[] = [];
  /** El aviso de lo que acaba de pasar (Mario, 12-oct: «más profesionales, no alertas así tan simples»). */
  aviso: { titulo: string; detalle?: string; icono?: string } | null = null;
  private avisoTimer?: ReturnType<typeof setTimeout>;
  avisar = (titulo: string, detalle = '', icono = 'fa-check'): void => {
    this.aviso = { titulo, detalle, icono };
    clearTimeout(this.avisoTimer);
    this.avisoTimer = setTimeout(() => { this.aviso = null; }, 9000);
  };

  // lista
  lotesLista: any[] = [];
  desde = '';
  hasta = '';
  filtroEstado = '';
  tandasSinLote: any[] = [];
  /** BSP-01/02: la tasa BCV del día del cierre (la misma del Cierre); el lote fija la suya al generar. */
  tasaDia: number | null = null;
  bsDia = (usd: number): number | null => (this.tasaDia ? Math.round((Number(usd) || 0) * this.tasaDia * 100) / 100 : null);
  origenes: any[] = [];
  /** FIR-07 (Mario, 24-oct): la lista de cuentas ya llegó (para no avisar «no hay» mientras carga). */
  origenesCargados = false;
  origenElegido: { [n: number]: string } = {};
  // INT-04: las integraciones encendidas (MANUAL siempre) y las cuentas de origen que admite cada una.
  integracionesLote: any[] = [];
  integracionElegida: { [n: number]: string } = {};
  origenesPor: { [code: string]: any[] } = {};
  armando: number | null = null;

  // ficha
  codigo: string | null = null;
  ficha: any = null;
  ocupado = false;
  anulando = false;
  motivoAnular = '';
  // LOT-12 a 15: anular lo pendiente de un lote enviado (gerente o director).
  anulandoEnviado = false;
  motivoEnviado = '';
  confirmoBanco = false;
  archivo: File | null = null;
  previa: any = null;

  constructor(private ruta: ActivatedRoute, private router: Router, private liq: LiquidacionService, public _auth: AuthService) { }

  get puedeProcesar(): boolean { return this._auth.hasPermission('liquidacion.lotes'); }

  ngOnInit(): void {
    this.ruta.queryParamMap.subscribe((q) => {
      const c = q.get('lote');
      // PAG-05: la página, el filtro y la búsqueda de los pagos viven en la URL (pp, pe, pq, pt).
      const pag = { pagina: Number(q.get('pp')) || 1, tam: Number(q.get('pt')) || 50, estado: q.get('pe') || '', q: q.get('pq') || '' };
      if (c !== this.codigo) { this.codigo = c; this.limpiarFicha(); this.pag = pag; this.busqueda = pag.q; this.codigo ? this.cargarFicha() : this.cargarLista(); return; }
      if (this.codigo) { const cambio = JSON.stringify(pag) !== JSON.stringify(this.pag); this.pag = pag; if (cambio) this.cargarPagos(); }
      else this.cargarLista();
    });
    this.liq.cuentasOrigen('MANUAL').then((r) => { this.origenes = (r && r.cuentas) || []; this.origenesPor['MANUAL'] = this.origenes; this.origenesCargados = true; }).catch(() => { });
    this.liq.integracionesDisponibles().then((r) => {
      this.integracionesLote = (r && r.integraciones) || [];
      for (const i of this.integracionesLote.filter((x: any) => x.code !== 'MANUAL')) {
        this.liq.cuentasOrigen(i.code).then((c) => { this.origenesPor[i.code] = (c && c.cuentas) || []; }).catch(() => { });
      }
    }).catch(() => { });
  }

  ngOnChanges(): void { this.desde = this.dia; this.hasta = this.dia; if (!this.codigo) this.cargarLista(); }

  private limpiarFicha(): void { this.ficha = null; this.archivo = null; this.previa = null; this.anulando = false; this.motivoAnular = ''; this.anulandoEnviado = false; this.motivoEnviado = ''; this.confirmoBanco = false; this.error = ''; this.detalle = []; this.aviso = null; this.pagina = null; this.cache.clear(); }

  /** LPR-01: cuántos pagos de este lote siguen en «Por resolver» (los ya reintentados o retenidos no cuentan). */
  pendientesDelLote = 0;
  private cargarPorResolver = async (): Promise<void> => {
    this.pendientesDelLote = 0;
    if (!this.lote || this.lote.state !== 'CERRADO') return;
    try { const r = await this.liq.noProcesados(); this.pendientesDelLote = ((r && r.pagos) || []).filter((p: any) => p.lote === this.lote.code).length; } catch (e) { }
  };
  /** LPR-01: del lote cerrado con no procesados a la pestaña «Por resolver» del día del lote. */
  irAPorResolver = (): void => {
    this.router.navigate(['/console/liquidacion'], { queryParams: { dia: this.lote?.dia || this.dia || null, vista: 'resolver', lote: null } });
  };
  abrir = (code: string | null): void => { this.router.navigate([], { queryParams: { lote: code }, queryParamsHandling: 'merge' }); };

  // ══ lista (vista 6) ══
  cargarLista = async (): Promise<void> => {
    if (!this.dia) return;
    this.cargando = true; this.error = '';
    try {
      const [lista, cierre, delDia] = await Promise.all([
        this.liq.lotes({ desde: this.desde || this.dia, hasta: this.hasta || this.dia, estado: this.filtroEstado }),
        this.liq.vistaCierre(this.dia).catch(() => null),
        this.liq.lotes({ dia: this.dia }),
      ]);
      this.lotesLista = lista || [];
      const conLote = new Set((delDia || []).filter((l: any) => l.state !== 'ANULADO').map((l: any) => l.tanda));
      this.tandasSinLote = ((cierre && cierre.tandas) || []).filter((t: any) => t.state === 'APROBADA' && !conLote.has(t.n));
      this.tasaDia = (cierre && cierre.tasa) || null;
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudieron leer los lotes.'; }
    finally { this.cargando = false; }
  };

  get abiertos(): any[] { return this.lotesLista.filter((l) => !['CERRADO', 'ANULADO'].includes(l.state)); }
  get porProcesar(): any[] { return this.lotesLista.filter((l) => ['BORRADOR', 'GENERADO'].includes(l.state)); }
  get enElBanco(): any[] { return this.lotesLista.filter((l) => ['DESCARGADO', 'ENVIADO', 'RESPUESTA_PARCIAL'].includes(l.state)); }
  get noProcesadosRango(): number { return this.lotesLista.reduce((s, l) => s + ((l.totales && l.totales.no_procesados) || 0), 0); }
  suma = (ls: any[], k: string): number => Math.round(ls.reduce((s, l) => s + ((l.totales && Number(l.totales[k])) || 0), 0) * 100) / 100;

  metodoDe = (n: number): string => this.integracionElegida[n] || 'MANUAL';
  /** FIR-07: pedida la lista del método de la tanda (`?metodo=`) y vino vacía → aviso con enlace en vez de un select vacío. */
  sinOrigenes = (n: number): boolean => this.origenesCargados && !!this.origenesPor[this.metodoDe(n)] && !this.origenesDe(n).length;
  origenesDe = (n: number): any[] => this.origenesPor[this.metodoDe(n)] || [];
  elegirIntegracion = (n: number, code: string): void => { this.integracionElegida[n] = code; this.origenElegido[n] = undefined as any; };
  /** INT-04: el nombre del archivo para el banco lo da el núcleo (el de la versión del lote); sin él, el código del lote. */
  get nombreArchivoBanco(): string { return (this.ficha && this.ficha.archivo_nombre) || `${this.lote.code.toLowerCase()}.txt`; }
  /** INT-04: el lote manual baja el Excel; uno con integración del banco, su archivo (.txt). */
  get esManual(): boolean { return !this.lote || !this.lote.method || this.lote.method === 'MANUAL'; }
  get nombreIntegracion(): string { const i = this.integracionesLote.find((x: any) => x.code === (this.lote && this.lote.method)); return i ? i.nombre : (this.esManual ? 'pago manual' : this.lote.method); }

  armarLote = async (t: any): Promise<void> => {
    const origen = this.origenElegido[t.n];
    const metodo = this.metodoDe(t.n);
    if (!origen) { this.error = `Elige la cuenta origen de la tanda ${t.n}.`; return; }
    this.armando = t.n; this.error = ''; this.detalle = [];
    try {
      const r = await this.liq.armarLote(this.dia, t.n, origen, metodo);
      this.avisar(`Lote ${r.lote.code} armado`, `${r.items.length} pago(s) listos para generar el archivo${r.fuera.length ? ` · ${r.fuera.length} quedaron fuera (ver su motivo)` : ''}.`, 'fa-layer-group');
      this.detalle = (r.fuera || []).map((f: any) => `${f.code}: ${f.motivo}`);
      this.abrir(r.lote.code);
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo armar el lote.'; }
    finally { this.armando = null; }
  };

  // ══ ficha (vista 7) ══
  cargarFicha = async (): Promise<void> => {
    if (!this.codigo) return;
    this.cargando = true;
    const antes = this.lote && this.lote.code === this.codigo ? this.pasosHechos(this.lote) : null;
    try { this.ficha = await this.liq.lote(this.codigo); this.celebrarAvance(antes); this.cache.clear(); this.cargarPagos(); this.cargarPorResolver(); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el lote.'; }
    finally { this.cargando = false; }
  };

  /** Los pasos que se acaban de completar (para su animación) y si el lote terminó recién (supermódulo, Mario 12-oct). */
  recien = new Set<number>();
  terminoRecien = false;
  private animacion?: ReturnType<typeof setTimeout>;
  private celebrarAvance(antes: number | null): void {
    if (antes == null || !this.lote) return;
    const ahora = this.pasosHechos(this.lote);
    if (ahora <= antes) return;
    this.recien = new Set(Array.from({ length: ahora - antes }, (_, i) => antes + i));
    this.terminoRecien = this.lote.state === 'CERRADO';
    clearTimeout(this.animacion);
    this.animacion = setTimeout(() => { this.recien = new Set(); this.terminoRecien = false; }, this.terminoRecien ? 3200 : 1800);
  }

  get lote(): any { return this.ficha && this.ficha.lote; }
  /** LOT-16: anulado después de enviar = tiene la fecha de la anulación (todo lote trae el objeto, vacío). */
  get anuladoTrasEnvio(): boolean { return !!(this.lote && this.lote.cancelled_after_sent && this.lote.cancelled_after_sent.at); }
  // ── PAG-05: los pagos llegan por página; las cifras, del resumen que calcula el núcleo ──
  pag = { pagina: 1, tam: 50, estado: '', q: '' };
  pagina: any = null;
  cargandoPagos = false;
  busqueda = '';
  private cache = new Map<string, any>();
  private busquedaTimer?: ReturnType<typeof setTimeout>;
  get resumen(): any { return this.ficha && this.ficha.resumen; }
  /** Los pagos de la página que se ve. */
  get items(): any[] { return (this.pagina && this.pagina.items) || []; }
  private claveDe = (p: any): string => `${this.codigo}|${p.pagina}|${p.tam}|${p.estado}|${p.q}`;
  private traerPagina = (p: any): Promise<any> => {
    const k = this.claveDe(p);
    if (!this.cache.has(k)) this.cache.set(k, this.liq.pagosLote(this.codigo as string, p).catch((e) => { this.cache.delete(k); throw e; }));
    return this.cache.get(k);
  };
  /** Sin parpadeo: la página anterior se queda hasta que llega la nueva. */
  cargarPagos = async (): Promise<void> => {
    if (!this.codigo) return;
    const p = { ...this.pag };
    this.cargandoPagos = true;
    try { const r = await this.traerPagina(p); if (this.claveDe(p) === this.claveDe(this.pag)) this.pagina = r; }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudieron leer los pagos del lote.'; }
    finally { this.cargandoPagos = false; }
  };
  /** Al pasar el mouse por «siguiente», la página que viene ya se va pidiendo. */
  adelantar = (n: number): void => { if (this.pagina && n >= 1 && n <= this.pagina.paginas) this.traerPagina({ ...this.pag, pagina: n }).catch(() => { }); };
  private aLaUrl = (): void => {
    this.router.navigate([], { queryParams: { pp: this.pag.pagina > 1 ? this.pag.pagina : null, pt: this.pag.tam !== 50 ? this.pag.tam : null,
      pe: this.pag.estado || null, pq: this.pag.q || null }, queryParamsHandling: 'merge', replaceUrl: true });
  };
  irAPagina = (n: number): void => {
    const max = (this.pagina && this.pagina.paginas) || 1;
    this.pag = { ...this.pag, pagina: Math.min(Math.max(1, n), max), q: this.busqueda.trim() };
    this.aLaUrl(); this.cargarPagos();
  };
  filtrarPagos = (estado: string): void => { this.pag = { ...this.pag, estado, pagina: 1 }; this.aLaUrl(); this.cargarPagos(); };
  cambiarTam = (tam: number): void => { this.pag = { ...this.pag, tam, pagina: 1 }; this.aLaUrl(); this.cargarPagos(); };
  /** La búsqueda espera a que se deje de escribir. */
  buscarPagos = (t: string): void => { this.busqueda = t; clearTimeout(this.busquedaTimer); this.busquedaTimer = setTimeout(() => this.irAPagina(1), 300); };
  /** Los números de página con «…»: 1 … 4 5 6 … 247. */
  get numerosDePagina(): (number | null)[] {
    const t = (this.pagina && this.pagina.paginas) || 1, a = this.pag.pagina;
    const set = new Set([1, t, a - 1, a, a + 1].filter((n) => n >= 1 && n <= t));
    const ns = [...set].sort((x, y) => x - y), out: (number | null)[] = [];
    ns.forEach((n, i) => { if (i && n - ns[i - 1] > 1) out.push(null); out.push(n); });
    return out;
  }
  descargarInforme = async (): Promise<void> => {
    this.error = '';
    try {
      const blob = await this.liq.informeLote(this.lote.code);
      guardarArchivo(blob, `informe-${this.lote.code.toLowerCase()}.xlsx`);
      this.avisar('Informe descargado', `El lote completo: resumen y ${(this.resumen?.n || 0).toLocaleString('es-VE')} pago(s).`, 'fa-file-excel');
    } catch { this.error = 'No se pudo descargar el informe del lote.'; }
  };
  /** Totales del lote, del resumen (PAG-03): `amount_usd` o `amount_bs`, de todos o de un resultado. */
  totalItems = (k: string, estado?: string): number => {
    const r = this.resumen; if (!r) return 0;
    const campo = k === 'amount_bs' ? 'bs' : 'usd';
    return estado ? ((r.por_estado[estado] && r.por_estado[estado][campo]) || 0) : r[campo] || 0;
  };
  cuenta = (estado: string): number => (this.resumen?.por_estado?.[estado]?.n) || 0;

  /** El paso en curso (0..4); -1 si terminó o se anuló. */
  pasoActual = (l: any): number => {
    if (!l || ['CERRADO', 'ANULADO'].includes(l.state)) return -1;
    if (l.state === 'RESPUESTA_PARCIAL') return 3;
    const s = l.steps || {};
    return this.PASOS.findIndex((p) => !(s[p.k] && s[p.k].at));
  };
  pasosHechos = (l: any): number => (l && l.state === 'CERRADO' ? 5 : this.PASOS.filter((p) => l && l.steps && l.steps[p.k] && l.steps[p.k].at && !(p.k === 'response' && l.state === 'RESPUESTA_PARCIAL')).length);
  pasoHecho = (l: any, k: number): boolean => this.pasoActual(l) === -1 ? l.state === 'CERRADO' || !!(l.steps && l.steps[this.PASOS[k].k]) : k < this.pasoActual(l);
  /** Los comercios del lote, sin repetir, para su estampa en la cabecera. */
  get comerciosDelLote(): string[] { return (this.resumen && this.resumen.comercios && this.resumen.comercios.primeros) || []; }
  get nComercios(): number { return (this.resumen && this.resumen.comercios && this.resumen.comercios.n) || 0; }
  /** Cuánto del riel va lleno: hasta el paso actual (o todo, si terminó). */
  progreso = (l: any): number => {
    const a = this.pasoActual(l);
    return a === -1 ? (l && l.state === 'CERRADO' ? 100 : 0) : Math.round((a / (this.PASOS.length - 1)) * 100);
  };
  /** La barra de los pagos: pagado · no procesado · pendiente, en % del total. */
  pctPagos = (estado: string): number => (this.resumen?.n ? Math.round((this.cuenta(estado) / this.resumen.n) * 1000) / 10 : 0);
  quien = (id: string): string => (this.ficha && this.ficha.personas && this.ficha.personas[id]) || 'otra persona';
  hora = (f: any): string => {
    const d = new Date(new Date(f).getTime() - 4 * 3600e3);
    return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')} ${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
  };

  private async accion(fn: () => Promise<any>, ok: [string, string, string?], falla: string): Promise<void> {
    this.ocupado = true; this.error = ''; this.detalle = []; this.aviso = null;
    try { await fn(); this.avisar(ok[0], ok[1], ok[2]); await this.cargarFicha(); }
    catch (e: any) { this.error = e?.error?.msg || falla; this.detalle = e?.error?.detalle || []; }
    finally { this.ocupado = false; }
  }

  cambiarOrigen = (code: string): Promise<void> => this.accion(() => this.liq.cambiarCuentaOrigen(this.lote.code, code), ['Cuenta origen cambiada', `El lote ahora sale de ${code}.`, 'fa-university'], 'No se pudo cambiar la cuenta origen.');
  generar = (): Promise<void> => this.accion(() => this.liq.generarLote(this.lote.code), ['Archivo generado', 'La tasa BCV del día quedó fijada, junto con la foto de cada cuenta destino y la suma de control.', 'fa-file-signature'], 'No se pudo generar el archivo.');
  enviar = (): Promise<void> => this.accion(() => this.liq.enviarLote(this.lote.code), ['Pagado en la banca', 'Quedó registrado quién y cuándo. El siguiente paso es cargar la respuesta del banco.', 'fa-university'], 'No se pudo marcar el envío.');
  anular = async (): Promise<void> => {
    if (!this.motivoAnular.trim()) { this.error = 'Para anular el lote escribe el motivo.'; return; }
    await this.accion(() => this.liq.anularLote(this.lote.code, this.motivoAnular.trim()), ['Lote anulado', 'Sus pagos volvieron a estar por pagar y pueden entrar en un lote nuevo.', 'fa-ban'], 'No se pudo anular.');
    this.anulando = false; this.motivoAnular = '';
  };

  /** Los pendientes del lote (del resumen): cuántos y una muestra de sus códigos. */
  get nPendientes(): number { return this.cuenta('PENDIENTE'); }
  get codigosPendientes(): string {
    const m: string[] = (this.resumen && this.resumen.pendientes_muestra) || [];
    return m.join(', ') + (this.nPendientes > m.length ? ` y ${this.nPendientes - m.length} más` : '');
  }
  anularEnviado = async (): Promise<void> => {
    if (!this.motivoEnviado.trim() || !this.confirmoBanco) { this.error = 'Para anular escribe el motivo y confirma que hablaste con el banco.'; return; }
    const n = this.nPendientes;
    await this.accion(() => this.liq.anularLoteEnviado(this.lote.code, this.motivoEnviado.trim(), this.confirmoBanco),
      [`${n} pago(s) anulado(s)`, 'Volvieron a estar por pagar. Si el banco los paga igual, la respuesta los manda a «Por resolver».', 'fa-ban'], 'No se pudo anular.');
    this.anulandoEnviado = false; this.motivoEnviado = ''; this.confirmoBanco = false;
  };
  /** Lo que aplica la respuesta: pagados, no procesados y (LOT-16) pagados después de anular. */
  get resultadosPrevia(): number { return this.previa ? (this.previa.pagados || 0) + (this.previa.no_procesados || 0) + (this.previa.pagados_tras_anular || 0) : 0; }

  descargarArchivo = async (): Promise<void> => {
    this.error = '';
    try {
      const blob = await this.liq.archivoLote(this.lote.code);
      guardarArchivo(blob, this.nombreArchivoBanco, 'text/plain');
      await this.cargarFicha();
    } catch (e: any) { this.error = 'No se pudo descargar el archivo para el banco.'; }
  };
  descargar = (): Promise<void> => (this.esManual ? this.descargarExcel() : this.descargarArchivo());

  descargarExcel = async (): Promise<void> => {
    this.error = '';
    try {
      const blob = await this.liq.excelLote(this.lote.code);
      guardarArchivo(blob, `${this.lote.code.toLowerCase()}.xlsx`);
      await this.cargarFicha();
    } catch (e: any) { this.error = 'No se pudo descargar el Excel del lote.'; }
  };

  elegirArchivo = async (ev: Event): Promise<void> => {
    const f = (ev.target as HTMLInputElement).files;
    this.archivo = f && f.length ? f[0] : null;
    this.previa = null; this.error = ''; this.detalle = []; this.aviso = null;
    if (!this.archivo) return;
    this.ocupado = true;
    try { this.previa = await this.liq.respuestaLote(this.lote.code, this.archivo, true); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el archivo.'; }
    finally { this.ocupado = false; (ev.target as HTMLInputElement).value = ''; }
  };
  descartar = (): void => { this.archivo = null; this.previa = null; this.error = ''; this.detalle = []; };
  aplicar = async (): Promise<void> => {
    if (!this.archivo) return;
    const a = this.archivo, pv = this.previa || {};
    const partes = [pv.pagados ? `${pv.pagados} pagado(s)` : '', pv.no_procesados ? `${pv.no_procesados} no procesado(s), van a «Por resolver»` : '',
      pv.sin_procesar ? `${pv.sin_procesar} siguen pendientes` : ''].filter(Boolean);
    await this.accion(async () => {
      const r = await this.liq.respuestaLote(this.lote.code, a, false);
      this.archivo = null; this.previa = null;
      return r;
    }, ['Respuesta del banco aplicada', partes.length ? partes.join(' · ') + '.' : 'Se registró el resultado de cada pago.', 'fa-file-import'], 'No se pudo aplicar la respuesta.');
  };

  estado = (s: string): { texto: string; clase: string } => ({
    BORRADOR: { texto: 'Borrador', clase: 'kb-badge-neutro' }, GENERADO: { texto: 'Generado', clase: 'kb-badge-neutro' },
    DESCARGADO: { texto: 'Descargado', clase: 'kb-badge-alerta' }, ENVIADO: { texto: 'En el banco', clase: 'kb-badge-alerta' },
    RESPUESTA_PARCIAL: { texto: 'Respuesta parcial', clase: 'kb-badge-alerta' }, CERRADO: { texto: 'Cerrado', clase: 'kb-badge-exito' },
    ANULADO: { texto: 'Anulado', clase: 'kb-badge-contorno' }, GER: { texto: 'gerente de finanzas', clase: '' }, DIR: { texto: 'director', clase: '' },
    PENDIENTE: { texto: 'Pendiente', clase: 'kb-badge-neutro' }, PAGADO: { texto: 'Pagado', clase: 'kb-badge-exito' },
    NO_PROCESADO: { texto: 'No procesado', clase: 'kb-badge-peligro' }, SIN_PROCESAR: { texto: 'Sin procesar', clase: 'kb-badge-neutro' },
    DESCONOCIDO: { texto: 'Estado no válido', clase: 'kb-badge-peligro' },
  } as any)[s] || { texto: s, clase: 'kb-badge-neutro' };

  /** LOT-17: el selector dice banco y final de la cuenta; la ficha completa va debajo. */
  final = (n: string): string => String(n || '').replace(/\D/g, '').slice(-4);
  origenPorCodigo = (code: string, lista: any[]): any => (lista || []).find((o) => o.code === code) || null;
  enmascarar = (n: string): string => { const d = String(n || '').replace(/\D/g, ''); return d.length >= 8 ? `${d.slice(0, 4)}-····-${d.slice(-4)}` : d; };
  fecha = (iso: string): string => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '');
}
